<template>
    <div class="tw-flex tw-items-center item tw-w-full tw-flex-wrap">
      <div class="tw-flex tw-w-full md:tw-w-6/12 md:tw-pr-2">
        <v-text-field 
          v-mask="'#####-###'" 
          :masked="false" 
          @blur="$emit('check-cep')" 
          :rules="rules.zipCode" 
          label="CEP"
          id="cep" 
          name="cep" 
          type="text" 
          :value="value.zipCode"
          @input="updateField('zipCode', $event)"
          dense 
          light 
          color="#4f1087"
          filled
        ></v-text-field>
      </div>
      <div class="tw-flex tw-w-full md:tw-w-6/12 md:tw-pl-2">
        <v-autocomplete 
          :value="value.uf"
          @input="updateField('uf', $event)"
          light 
          dense 
          filled 
          color="#4f1087" 
          label="Estado"
          :rules="rules.required" 
          :items="states" 
          item-text="id" 
          item-value="id"
        ></v-autocomplete>
      </div>
      <div class="tw-flex tw-w-full md:tw-w-6/12 md:tw-pr-2">
        <v-text-field 
          :value="value.city"
          @input="updateField('city', $event)"
          light 
          dense 
          filled 
          color="#4f1087" 
          label="Cidade"
          :rules="rules.required"
        ></v-text-field>
      </div>
      <div class="tw-flex tw-w-full md:tw-w-6/12 md:tw-pl-2">
        <v-text-field 
          :value="value.district"
          @input="updateField('district', $event)"
          light 
          dense 
          filled 
          color="#4f1087" 
          label="Bairro"
          :rules="rules.required"
        ></v-text-field>
      </div>
      <div class="tw-flex tw-w-full md:tw-w-6/12 md:tw-pr-2">
        <v-text-field 
          :value="value.street"
          @input="updateField('street', $event)"
          light 
          dense 
          filled 
          color="#4f1087" 
          label="Logradouro"
          :rules="rules.required"
        ></v-text-field>
      </div>
      <div class="tw-flex tw-w-full md:tw-w-6/12 md:tw-pl-2">
        <v-text-field 
          :value="value.streetNumber"
          @input="updateField('streetNumber', $event)"
          light 
          dense 
          filled 
          color="#4f1087"
          label="Número"
        ></v-text-field>
      </div>
    </div>
  </template>
  
  <script>
  import { mask } from 'vue-the-mask'
  
  export default {
    directives: { mask },
    props: {
      value: {
        type: Object,
        required: true
      },
      rules: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        states: [
          { id: "AC" }, { id: "AL" }, { id: "AP" }, { id: "AM" },
          { id: "BA" }, { id: "BH" }, { id: "CE" }, { id: "DF" },
          { id: "ES" }, { id: "GO" }, { id: "MA" }, { id: "MT" },
          { id: "MS" }, { id: "MG" }, { id: "PA" }, { id: "PB" },
          { id: "PR" }, { id: "PE" }, { id: "PI" }, { id: "RJ" },
          { id: "RN" }, { id: "RS" }, { id: "RO" }, { id: "RR" },
          { id: "SC" }, { id: "SP" }, { id: "SE" }, { id: "TO" }
        ]
      }
    },
    methods: {
      updateField(field, value) {
        const updatedValue = {
          ...this.value,
          [field]: value
        }
        this.$emit('input', updatedValue)
      }
    }
  }
  </script>